import { required } from 'vuelidate/lib/validators'
import LocalePicker from '@/components/common/localepicker/LocalePicker.vue'

export default {
  name: 'EmailTestSend',
  data () {
    return {
      email: '',
      locale: null,
      loading: false,
      message: null,
      sendAsMyself: true
    }
  },
  components: {
    LocalePicker
  },
  validations: {
    email: { required }
  },
  computed: {
    getTitle () {
      return this.$t('menu.config.emails.messages.test-send');
    }
  },
  methods: {
    show (message) {
      this.email = this.$session.get('email');
      this.message = message;
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    send () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { email: this.email, message: this.message.code, locale: this.locale, sendAsMyself: this.sendAsMyself };
        const self = this;
        this.ApiRequest.request('config/emails/send-message', this.ApiRequest.REQUEST_POST, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
